import * as React from 'react';

interface ICollapsibleComponentProps
{
	/** Необходимость заполнения */
	IsRequired: boolean,

	/** Текст внутри заголовка */
	HeaderText: string,

	/** Ошибка, отображаемая в заголовке */
	ErrorText?: string,

	/** Идентификатор для компонента */
	ID: string,

	/** Показывать ли зеленый значек */
	IsCompleted: boolean,

	/** Показывать ли вообще значки */
	IsValidated: boolean,

	/** Вложенные элементы */
	children: any
}


export const CollapsibleComponent: React.FC<ICollapsibleComponentProps> = 
	(
		// входные параметры компонента
		{ IsRequired, HeaderText, ErrorText, ID, IsCompleted, IsValidated, children }: ICollapsibleComponentProps
	) =>
	{
		return (
			<div className={"accordion" + (IsValidated?((ErrorText ? " danger" : "") + (IsCompleted ? " complete" : "")):"")}>
				<input type="checkbox" className="accordion-switcher" id={ID} />
				<label htmlFor={ID}>
					<span className="accordion-title">{HeaderText}&nbsp;{IsRequired && <span className="text-danger">*</span>}</span>
					<span className="accordion-title-icon" title={ErrorText}></span>
					<span className="accordion-title-arrow">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M17.2946 9.29446C16.9053 8.90519 16.2743 8.90484 15.8846 9.29369L12.1413 13.0289C12.0632 13.1068 11.9368 13.1068 11.8587 13.0289L8.11538 9.29369C7.72569 8.90484 7.09466 8.90519 6.70538 9.29446C6.31581 9.68403 6.31581 10.3157 6.70538 10.7052L11.2929 15.2927C11.6834 15.6833 12.3166 15.6833 12.7071 15.2927L17.2946 10.7052C17.6842 10.3157 17.6842 9.68403 17.2946 9.29446Z" fill="#303236" />
						</svg>
					</span>
				</label>
				<div className="accordion-content-wrapper">
						{children}
				</div>
			</div>
		);
	}
